<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :stroke="color"
      d="M29.2503 40.0834L14.667 25.5001L29.2503 10.9167"
      stroke-opacity="0.3"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'IconChevronLeftThin',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    width: {
      type: [Number, String],
      default: 48,
    },
    height: {
      type: [Number, String],
      default: 51,
    },
  },
}
</script>
